export default "__VITE_ASSET__2a57a44c__"